<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <v-card>
        <!-- 搜索栏  -->
        <v-toolbar color="success">
          <v-toolbar-title class="white--text">
            <div style="padding-left: 20px">工具库</div>
          </v-toolbar-title>
          <v-btn
            large
            class="md-button md-success dropdown-toggle"
            @click="handleResourceNew"
          >
            <v-icon small>mdi-account-plus</v-icon> 新建工具模型
          </v-btn>
          <v-spacer></v-spacer>
          <div class="d-sm-flex justify-between">
            <div class="d-flex ms-auto">
              <v-menu
                v-for="(list, index) in queryParams"
                :key="index"
                transition="slide-y-transition"
                offset-y
                nudge-bottom="5"
                :close-on-click="true"
                :disabled="list.disabled"
              >
                <template v-slot:activator="{ on, attrs, value }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="md-button md-success dropdown-toggle"
                    :class="list.disabled ? 'disable-color' : ''"
                  >
                    {{ list.title }}
                    <v-icon :class="['ni', value ? 'rotate-180' : '']"
                      >ni ni-bold-down text-xs ms-1</v-icon
                    >
                  </v-btn>
                </template>

                <v-list class="py-1" dense max-height="300">
                  <v-list-item-group
                    v-model="list.value"
                    active-class="v-List-actived"
                    mandatory
                    color="indigo"
                    @change="changeQueryParams(list, $event)"
                  >
                    <v-list-item
                      class="list-item-hover-active py-0 text-center"
                      v-for="(item, index) in list.listData"
                      :key="index"
                    >
                      <v-list-item-content class="pa-0">
                        <v-list-item-title
                          v-text="item.name"
                          class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                        >
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>
              <v-btn
                class="md-button md-success dropdown-toggle"
                @click="clearFilter"
              >
                清除筛选
                <md-icon>filter_list_off</md-icon>
              </v-btn>
            </div>
          </div>
        </v-toolbar>
        <v-card-text class="px-3 py-0">
          <v-toolbar flat height="80">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="searchQuery"
                  v-bind="attrs"
                  v-on="on"
                  append-icon="mdi-magnify"
                  label="请输入名称"
                  single-line
                  hide-details
                  @keydown="keydownSearch"
                ></v-text-field>
              </template>
              <span>按回车以检索</span>
            </v-tooltip>
            <!-- <v-spacer></v-spacer>
                <v-btn
                  height="35"
                  :ripple="false"
                  small
                  elevation="0"
                  class="font-weight-normal text-capitalize btn-primary bg-gradient-success py-3 px-6 ms-3"
                  >新增</v-btn
                > -->
          </v-toolbar>
          <v-row dense>
            <v-col class="px-3" cols="12" v-show="loading"
              ><v-progress-linear
                :active="loading"
                :indeterminate="loading"
              ></v-progress-linear
            ></v-col>
            <v-col
              v-for="modelResource in modelResourceList"
              :key="modelResource.id"
              cols="3"
              class="py-3"
            >
              <v-hover>
                <template v-slot:default="{ hover }">
                  <v-expand-transition>
                    <v-card
                      hover
                      :class="[
                        `elevation-${hover ? 20 : 2}`,
                        'mx-2',
                        'transition-swing',
                      ]"
                      @click="handleResourceDetail(modelResource)"
                    >
                      <v-img
                        :src="modelResource.model_image"
                        class="white--text align-end"
                        gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                        height="200px"
                      >
                        <v-card-title
                          v-text="modelResource.model_name"
                        ></v-card-title>
                      </v-img>

                      <v-card-actions>
                        <v-spacer></v-spacer>

                        <div class="d-flex align-content-center">
                          <div class="text-success">免费</div>
                        </div>
                      </v-card-actions>
                    </v-card>
                  </v-expand-transition>
                </template>
              </v-hover>
            </v-col>
          </v-row>
        </v-card-text>
        <!-- 分页 -->
        <Pagination
          :page.sync="pagination.page"
          :total="pagination.total"
          :itemsSelect="[4, 8, 20, 40]"
          :items-per-page.sync="pagination.itemsPerPage"
          @refresh="refreshResourceList"
        />
        <ToolLibDetail
          :showDetailDialog="showDetailDialog"
          :selectedResource="selectedResource"
          @handleDetailCancel="handleDetailCancel"
          @handleDetailSubmit="handleDetailSubmit"
          v-if="showDetailDialog"
        />
        <ToolLibNew
          :showNewDialog="showNewDialog"
          @handleCloseDialog="handleCloseDialog"
          v-if="showNewDialog"
        />
      </v-card>
    </div>
  </div>
</template>
<script>
import ToolLibDetail from "./Action/ToolLibDetail";
import ToolLibNew from "./Action/ToolLibNew";
import Pagination from "@/components/Pagination/index";
import { refreshResourceList } from "@/api/model_resource";

export default {
  name: "ToolLib",
  components: {
    ToolLibDetail,
    ToolLibNew,
    Pagination,
  },
  data() {
    return {
      // 搜索条件
      searchQuery: "",
      // 加载
      loading: true,
      // 查询参数
      queryParams: [
        {
          level: "Level_1",
          value: 0,
          code: "",
          title: "专业分类",
          listData: [],
          disabled: false,
        },
        {
          level: "Level_2",
          value: 0,
          code: "",
          title: "二级分类",
          listData: [],
          disabled: true,
        },
        {
          level: "Level_3",
          value: 0,
          code: "",
          title: "三级分类",
          listData: [],
          disabled: true,
        },
      ],
      // 分页
      pagination: {
        page: 1,
        itemsPerPage: 8,
        total: 0,
      },
      showDetailDialog: false,
      showNewDialog: false,
      checkList: [],
      selectedItem: {},
      modelResourceList: [],
      selectedResource: {},
    };
  },
  computed: {},
  watch: {},
  created() {
    this.refreshResourceList();

    this.initDict("tool");
  },
  methods: {
    /**
     * 初始化字典
     */
    initDict(cate_type) {
      let arr = {
        code: "-1",
        name: "全部",
      };
      this.$dic.getCategoryList(
        {
          cate_type: cate_type,
          level: "1",
        },
        (res) => {
          if (res.length > 0) {
            res.unshift(arr);
          }
          this.queryParams[0].listData = res;
          this.queryParams[0].code = "";
        }
      );

      this.$dic.getCategoryList(
        {
          cate_type: cate_type,
          level: "2",
          parentCode: "00",
        },
        (res) => {
          this.queryParams[1].listData = res;
          this.queryParams[1].code = "";
        }
      );

      this.$dic.getCategoryList(
        {
          cate_type: cate_type,
          level: "3",
          parentCode: "00_01",
        },
        (res) => {
          this.queryParams[2].listData = res;
          this.queryParams[2].code = "";
        }
      );
    },
    /**
     * 选择框选择刷新
     */
    changeQueryParams(rows, index) {
      const map = {
        Level_1: () => {
          this.$dic.getCategoryList(
            {
              cate_type: "tool",
              level: "2",
              parentCode: rows.listData[index].code,
            },
            (res) => {
              this.queryParams[1].listData = res;
            }
          );
          this.$dic.getCategoryList(
            {
              cate_type: "tool",
              level: "3",
              parentCode: rows.listData[index].code + "_01",
            },
            (res) => {
              this.queryParams[2].listData = res;
            }
          );
          this.queryParams[0].code = rows.listData[index].code;
          this.pagination.page = 1;
          this.refreshResourceList();
        },
        Level_2: () => {
          console.log("Level_2");
        },
        Level_3: () => {
          console.log("Level_3");
        },
      };
      map[rows.level]();
    },
    /**
     * 搜索框点击enter事件
     */
    keydownSearch(e) {
      // 点击Enter
      if (e.keyCode === 13) {
        this.refreshResourceList();
      }
    },
    /**
     * 查看详情
     */
    handleResourceDetail(item) {
      console.log(11);
      this.showDetailDialog = true;
      this.selectedResource = item;
    },
    /**
     * 清除筛选
     */
    clearFilter() {
      this.searchQuery = "";
      this.queryParams.forEach((item) => {
        item.value = 0;
        item.code = "";
      });
      this.refreshResourceList();
    },
    refreshResourceList() {
      let tempData1 = {
        model_name: this.searchQuery || "",
        one_level_classify: this.queryParams[0].code, 
        page_no: this.pagination.page || "",
        status: "7",
        page_size: this.pagination.itemsPerPage,
        model_resource_category: "tool",
      };
      this.loading = true;
      refreshResourceList(tempData1).then((res) => {
        this.modelResourceList = res.data.items;
        this.pagination.total = res.data.total;
        this.loading = false;
      });
    },

    handleDetailSubmit(item) {
      this.pagination.page = 1;
      this.refreshResourceList();
      this.showDetailDialog = false;
    },
    handleResourceNew() {
      this.showNewDialog = true;
    },
    submit() {
      this.$emit("handleSubmit", {});
    },
    cancel() {
      this.$emit("handleCancel", {});
    },
    handleDetailCancel() {
      this.showDetailDialog = false;
    },
    handleCloseDialog(res) {
      this.showNewDialog = false;
      if (res) {
        this.refreshResourceList();
        console.log(res);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.img-card {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.img {
  width: 200px;
  height: 180px;
  margin: 0 !important;
}

.md-group {
  margin-bottom: 24px;
}

.md-button {
  border-radius: 0;
}

.md-tab {
  max-width: 600px;
  max-height: 400px;
  overflow: auto;
}
.v-List-actived {
  background: #ddd;
}
.v-application .indigo--text {
  background: #fff;
}
.disable-color {
  color: #ddd !important;
  i {
    color: #ddd !important;
  }
}
</style>
